import Swiper, { Autoplay, EffectFade } from 'swiper'
import 'swiper/swiper-bundle.css'
import back2top from "back2top";

Swiper.use([Autoplay, EffectFade])

export default {
  start() {
    this.initSwiper()
    this.mobileCollapse()
    this.initBack2Top()
  },

  initSwiper() {
    new Swiper(".swiper-container", {
      centeredSlides: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    })
  },

  mobileCollapse() {
    const btnCollapse = document.querySelector('.js-btn-collapse')

    if (btnCollapse) {
      btnCollapse.addEventListener('click', () => {
        const collapse = document.querySelector('.header-nav')
        collapse.classList.toggle('active')
      })
    }
  },

  initBack2Top() {
    const btn = document.querySelector('.btn-back-to-top')

    if (!btn) return

    btn.addEventListener('click', () => {
      back2top(0, 4)
    })

    this.initBack2TopPosition()

    window.addEventListener('resize', () => {
      this.initBack2TopPosition()
    })

    window.addEventListener('scroll', () => {
      if (document.documentElement.scrollTop > document.documentElement.offsetHeight) {
        if (!btn.classList.contains('show')) {
          btn.classList.add('show')
        }
      } else {
        if (btn.classList.contains('show')) {
          btn.classList.remove('show')
        }
      }
    })
  },

  initBack2TopPosition() {
    const content = document.querySelector('.app > .content')
    const btn = document.querySelector('.btn-back-to-top')

    btn.style.left = content.offsetLeft + content.offsetWidth + 10 + 'px'
  },
}
